import type { ProfileDetail } from "@/interface/auth";

function DataItem({ label, value }: { label: string; value: string }) {
  return (
    <div className="space-y-1">
      <span className="text-xs font-semibold text-slate-500">{label}</span>
      <p className="text-sm font-medium text-slate-900 dark:text-white">
        {value || "N/A"}
      </p>
    </div>
  );
}

export function ProfessionalTab({ profile }: { profile?: ProfileDetail | null }) {
  return (
    <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6 shadow-sm">
      <h2 className="text-lg font-bold text-primary mb-6 border-b border-slate-100 dark:border-slate-800 pb-4">
        Professional Information
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <DataItem
          label="Employee ID"
          value={profile?.employee_id?.toString() || ""}
        />
        <DataItem label="Employee Code" value={profile?.employee_code || ""} />
        <DataItem label="Job Role" value={profile?.job_role || ""} />
        <DataItem
          label="Experience"
          value={`${profile?.experience_years ?? 0} yrs ${profile?.experience_months ?? 0} mos`}
        />
        <DataItem label="Joining Date" value={profile?.joining_date || ""} />
        <DataItem
          label="Employment Type"
          value={profile?.employment_type || ""}
        />
        <DataItem
          label="Employment Status"
          value={profile?.employment_status || ""}
        />
        <DataItem
          label="Department"
          value={profile?.department_detail?.department_name || ""}
        />
        <DataItem label="Team" value={profile?.team_detail?.team_name || ""} />
        <DataItem
          label="Reporting Manager"
          value={profile?.reporting_manager_detail?.name || ""}
        />
        <DataItem
          label="HR Manager"
          value={profile?.hr_manager_detail?.name || ""}
        />
        <DataItem label="Work Location" value={profile?.work_location || ""} />
        <div className="md:col-span-2">
          <DataItem label="Work Email" value={profile?.work_email || ""} />
        </div>
        <DataItem
          label="Notice Period"
          value={
            profile?.notice_period_days
              ? `${profile.notice_period_days} Days`
              : ""
          }
        />
      </div>
    </div>
  );
}
